function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var GameHelpTemplate = require('./game-help.template');
var WelcomeTemplate = require('./game-help-overlay.template');
var SaitoOverlay = require('./../saito-overlay/saito-overlay');

/**
 * GameHelp is a small triangle that will show up on the bottom-left of the
 * screen and toggle an overlay that can be filled with customized advice
 * when the user clicks on it.
 */
var GameHelp = /*#__PURE__*/function () {
  /**
   * @param app - the Saito application
   * @param mod - reference to the game module
   */
  function GameHelp(app, mod) {
    _classCallCheck(this, GameHelp);
    this.app = app;
    this.game_mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.game_mod);
  }
  return _createClass(GameHelp, [{
    key: "hide",
    value: function hide() {
      var gh = document.querySelector('.game-help-triangle');
      if (gh) {
        gh.classList.remove('game-help-visible');
        gh.classList.add('game-help-hidden');
      }
    }
  }, {
    key: "renderCustomOverlay",
    value: function renderCustomOverlay() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.overlay.show(WelcomeTemplate());
      if (obj.title) {
        document.querySelector('.game-help-overlay-title').innerHTML = obj.title;
      }
      if (obj.text) {
        document.querySelector('.game-help-overlay-text').innerHTML = obj.text;
      }
      if (obj.img) {
        document.querySelector('.game-help-overlay').style.backgroundImage = "url(".concat(obj.img, ")");
      }
    }
  }, {
    key: "render",
    value: function render() {
      var targs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (targs.id) {
        if (this.game_mod.loadGamePreference("settlers_help_".concat(targs.id))) {
          return;
        }
      }
      if (duration > 0) {
        targs.duration = duration;
      }
      var gh = document.querySelector('.game-help-triangle');
      if (gh) {
        gh.classList.remove('game-help-hidden');
        gh.classList.add('game-help-visible');
      } else {
        this.app.browser.addElementToDom(GameHelpTemplate(targs));
        gh = document.querySelector('.game-help-triangle');
      }
      if (targs.line1) {
        document.querySelector('.game-help-text .line1').innerHTML = targs.line1;
      }
      if (targs.line2) {
        document.querySelector('.game-help-text .line2').innerHTML = targs.line2;
      }
      if (targs.fontsize) {
        document.querySelector('.game-help-text').style.fontSize = targs.fontsize;
      }
      if (targs.color) {
        document.querySelector('.game-help-triangle').style.background = targs.color;
      }
      if (targs.duration > 0) {
        setTimeout(function () {
          try {
            var _gh = document.querySelector('.game-help-triangle');
            if (_gh) {
              _gh.style.transition = 'opacity 0.5s ease';
              _gh.style.opacity = '0';
              setTimeout(function () {
                _gh.remove();
              }, 500); // Match this to the fade-out duration
            }
          } catch (err) {}
        }, targs.duration);
      }
      this.attachEvents(targs);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var targs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var gh = document.querySelector('.game-help-triangle');
      gh.onclick = function (e) {
        _this.hide();
        var opensOverlay = !!(targs.title || targs.text || targs.img);
        if (opensOverlay) {
          _this.renderCustomOverlay(targs);
        }
        if (typeof targs.callback === 'function') {
          targs.callback();
        }
        if (!opensOverlay) {
          return;
        }

        // Overlay events
        if (document.querySelector('.game-help-overlay-optout')) {
          document.querySelector('.game-help-overlay-optout').onclick = function (e) {
            _this.game_mod.saveGamePreference("settlers_help_".concat(targs.id), 'noshow');
            _this.overlay.close();
          };
        }
      };
    }
  }]);
}();
module.exports = GameHelp;